import React, { Component } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import axios from 'axios';
import { apiUrl, carImageUrl, currency, dummycarUrl} from'../Config/Config';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth, scrollToTopValidate, scrollToTop } from "../Helpers/SettingHelper";
import jsonImg from "../../common/images/json-file.svg";
const initialState = {
			username:'',
			firstname:'',
			lastname:'',
			email:'',
			phoneno:'',
			status:'',
			user_password: '',
            user_confirm_password: '',
            new_pass_type: 'password',
            confrim_pass_type: 'password',
            pass_show_hide_icon: 'shown',
            confirm_show_hide_icon: 'shown',
            selectedOption:{ value: 'active', label: 'Active'},
			selectedvalue:'',
			disablepasssword:true,
			domainlist:[],
			selectedDomainOption:'',
			selectedDomainvalue:'',
			domainlistlength:'',
			maxCharacterLimit : 20,
			json_title:"",
			image:'',
			images:"",
			 functionalEndpoints: false,

		};
		// const withRouter = WrappedComponent => props => {
		// 	const params = useParams();
		// 	const  navigate = useNavigate();
		// 	// etc... other react-router-dom v6 hooks
		  
		// 	return (
		// 	  <WrappedComponent
		// 		{...props}
		// 		params={params}
		// 		navigate ={navigate}
		// 		// etc...
		// 	  />
		// 	);
		//   };

		const withRouter = WrappedComponent => props => {
					const params = useParams();
					const  navigate = useNavigate();
					// etc... other react-router-dom v6 hooks
				  
					return (
					  <WrappedComponent
						{...props}
						params={params}
						navigate ={navigate}
						// etc...
					  />
					);
				  };
class Add extends Component {
	
	constructor(props)
	{
		CheckAuth();
		super(props);	
		this.state =  { ...initialState }
		
	    this.handleInputChange = this.handleInputChange.bind(this);
	   this.new_pass_show_hide = this.new_pass_show_hide.bind(this);
       this.confim_pass_show_hide = this.confim_pass_show_hide.bind(this);
       this.handleChange = this.handleChange.bind(this);

    }
	 handleInputChange(event) {

      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });
      if(name == 'password'){
      	this.setState({disablepasssword: false})
      }
    }
    handleChange = selectedOption => {
        this.setState({selectedOption})
        this.setState({  selectedvalue : selectedOption.value});
    };
	handledomainChange = selectedDomainOption => {
		
		this.setState({selectedDomainOption:selectedDomainOption})
		this.setState({  selectedDomainvalue : selectedDomainOption.value});
	
}
	componentDidMount() {
		var  selecteddomainOption ='';
		var selectedDomainvalue ='';
		document.title = PageTitle('Add user');
		// if(localStorage.getItem('admin_id') === null){
		// this.props.history.push('/');
		// }
		// let domainlist = [];
		// axios.post(apiUrl+"user/domainlist").then(res => {
		// 	if(res.data.status == "success"){
		// 		let i=0;
		// 		let domainlists = res.data.domainlist;
		
		// 		for(i; i<domainlists.length; i++){
					
		// 			domainlist[i] = { value: domainlists[i]['domain_id'], label: domainlists[i]['domain_name'] };
		// 		}
				
		// 		if(res.data.domainlist.length==1){
		// 		let	j=0;
		// 			for(j; j<res.data.domainlist.length; j++){
						
		// 			 selecteddomainOption = { value:domainlists[j]['domain_id'], label: domainlists[j]['domain_name'] };
		// 		    selectedDomainvalue = domainlists[j]['domain_id'];	
		// 		}
					
		// 			this.setState({selectedDomainOption:selecteddomainOption})
		// 			this.setState({selectedDomainvalue:selectedDomainvalue})
		// 		}

		// 	}       
		// });
    }
	new_pass_show_hide = () => {
    this.setState({
         new_pass_type: this.state.new_pass_type === 'input' ? 'password' : 'input',
         pass_show_hide_icon: this.state.new_pass_type === 'input' ? 'shown' : 'hiden'
        });
    }
    
    confim_pass_show_hide = () => {
    this.setState({
         confrim_pass_type: this.state.confrim_pass_type === 'input' ? 'password' : 'input',
         confirm_show_hide_icon: this.state.confrim_pass_type === 'input' ? 'shown' : 'hiden'
        });
    } 

		onChangeHandler = (event) => {
			const files = Array.from(event.target.files); // get selected files
			const previews = []; // for storing name + content
			let validFiles = [];

			// Loop through each selected file
			files.forEach((file) => {
				// Validate file type — must be JSON
				if (file.type !== "application/json") {
				alert(`Invalid file type: ${file.name}. Only JSON files allowed.`);
				return;
				}

				validFiles.push(file);

				// Create a FileReader for each file
				const reader = new FileReader();
				reader.onload = () => {
				previews.push({ name: file.name, content: reader.result });

				// When all files are loaded
				if (previews.length === validFiles.length) {
					this.setState({
					json_files: validFiles,       // store files for upload
					json_previews: previews       // store preview content
					});
				}
				};

    
    reader.readAsText(file);
  });
};

removeFile = (index) => {
  const newFiles = [...this.state.json_files];
  const newPreviews = [...this.state.json_previews];

  newFiles.splice(index, 1);
  newPreviews.splice(index, 1);

  this.setState({
    json_files: newFiles,
    json_previews: newPreviews
  });
};


	  onChangeHandlerold = (event) => {
		const files = Array.from(event.target.files);
		const previews = [];
	  
		files.forEach((file) => {
		  const reader = new FileReader();
		  reader.onloadend = () => {
			previews.push({ name: file.name, data: reader.result });
	  
			// Once all previews are read, update state
			if (previews.length === files.length) {
			  this.setState({
				images: files,
				image_previews: previews,
			  });
			}
		  };
		  reader.readAsDataURL(file);
		});
	  };
	  removeImage = (index) => {
		const newImages = [...this.state.images];
		const newPreviews = [...this.state.image_previews];
	  
		newImages.splice(index, 1);
		newPreviews.splice(index, 1);
	  
		this.setState({
		  images: newImages,
		  image_previews: newPreviews
		});
	  };
	  
	 	 
	  handleFormSubmit = () => {
  if (this.validateForm()) {
    this.setState({ Loading: true });

    const formPayload = this.state;
    var qs = require('qs');

    var status = '';
    if (formPayload.selectedvalue === '' && formPayload.selectedvalue !== 0) {
      status = formPayload.selectedOption.value;
    } else {
      status = formPayload.selectedvalue;
    }

    
    let postObject = {
      admin_id: localStorage.getItem("admin_id"),
      status: status,
	  json_title:formPayload.json_title,
	  functional_endpoints: this.state.functionalEndpoints ? 'yes' : 'no	',
    };

    let formData = new FormData();

   
    for (let k in postObject) {
      formData.append(k, postObject[k]);
    }

   
    if (formPayload.json_files && formPayload.json_files.length > 0) {
      formPayload.json_files.forEach((file, index) => {
        formData.append("json_files[]", file); 
      });
    }

    
    axios.post(apiUrl + "jsonaifeed/add", formData).then(res => {
      if (res.data.status === 'success') {
        $('.success_message').html('<div class="status_sucess"><h3>' + res.data.message + '</h3></div>');

        
        this.setState({
          json_files: [],
          json_previews: [],
          selectedOption: '',
          selectedvalue: '',
          Loading: false
        });

        // Redirect after 3 seconds
          						setTimeout(
						function() {
							$('.success_message').html(this.props.navigate('/json'));
						}
						.bind(this),
						3000
						);

      } else {
        this.setState({ Loading: false });
        $('.success_message').html('<div class="status_sucess"><h3>' + res.data.message + '</h3></div>');

        setTimeout(() => {
          $('.success_message').html('');
        }, 3000);
      }
    }).catch(err => {
      console.error(err);
      this.setState({ Loading: false });
      $('.success_message').html('<div class="status_sucess"><h3>Something went wrong. Please try again.</h3></div>');
      setTimeout(() => {
        $('.success_message').html('');
      }, 3000);
    });
  }
}

	 handleFormSubmitold = () => {
			if(this.validateForm()){
				this.setState({Loading:true});
				const formPayload = this.state;
				var qs = require('qs');
				
			    var status = '';
				if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
				    status =formPayload.selectedOption.value;
				}else{
				    status = formPayload.selectedvalue;
				}

				
				
				let postObject = {
					admin_id: localStorage.getItem("admin_id"),
					status: status,
					functional_endpoints: this.state.functionalEndpoints ? 'Y' : 'N',
				};
				
				let formData = new FormData();
				
				for (let k in postObject) {
					formData.append(k, postObject[k]);
				}
				if (formPayload.images && formPayload.images.length > 0) {
					formPayload.images.forEach((file, index) => {
					  formData.append("images[]", file); // or "images[index]"
					});
				  }
				axios.post(apiUrl+"jsonaifeed/add",formData).then(res => {
				 
					if(res.data.status === 'success'){
					   $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
						   this.setState({
							username:'',			
							firstname:'',
							lastname:'',
							email:'',
							phoneno:'',
							password: '',
							confirm_password:''
						   });
						   setTimeout(
						   function() {
							
							   $('.success_message').html('');
									// this.props.navigate('/chat');
									this.props.history.push('/chat');
						   }
						   .bind(this),
						   3000
						   );
					   }else{
						this.setState({Loading:false});
						   $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
						   setTimeout(
						   function() {
							   $('.success_message').html('');
						   }
						   .bind(this),
						   3000
						   );
					   }
				  }); 
			}
	}

validateForm() {
  const { selectedvalue, json_files ,json_title } = this.state;

  let errors = 0;

  // Validate JSON files selected
  if (!json_files || json_files.length === 0) {
    errors++;
    $('.errorimage').html('<span class="errorspan">Please fill the JSON file</span>');
  } else {
    $('.errorimage').html('');
  }

  if (!json_title || json_title.trim() === '') {
    errors++;
    $('.error_json_title').html('<span class="errorspan">Please fill the field</span>');
  } else {
    $('.error_json_title').html('');
  }

  if (errors > 0) {
    setTimeout(function () {
      scrollToTopValidate();
    }, 100);
    return false;
  } else {
    return true;
  }
}


		

    componentWillReceiveProps(Props){

    		if(Props.useradd !== this.props.useradd){
    		if(Object.keys(Props.useradd).length > 0){
				this.setState({Loading:false});

				if(Props.useradd[0].status === "success"){

				 $('.success_message').html('<div class="status_sucess"><h3>'+Props.useradd[0].message+'</h3></div>');
				scrollToTop();
						setTimeout(
						function() {
							$('.success_message').html(this.props.history.push('/user'));
						}
						.bind(this),
						3000
						);
					this.setState({username:'',firstname:'',lastname:'',email:'',phoneno:'',user_password:'',user_confirm_password:''})
					}else if(Props.useradd[0].status === "erroremail"){

					 $('.erroremail').html('<span class="errorspan">'+Props.useradd[0].message+'</span>');
				     	scrollToTop();
							setTimeout(
							function() {
								$('.erroremail').html('');
							}
							.bind(this),
							3000
							);
					}else if(Props.useradd[0].status === "errorphone"){

					 $('.errorphoneno').html('<span class="errorspan">'+Props.useradd[0].message+'</span>');
				     	scrollToTop();
							setTimeout(
							function() {
								$('.errorphoneno').html('');
							}
							.bind(this),
							3000
							);
					}else if(Props.useradd[0].status === "errorusername"){

					 $('.errorusername').html('<span class="errorspan">'+Props.useradd[0].message+'</span>');
				     	scrollToTop();
							setTimeout(
							function() {
								$('.errorusername').html('');
							}
							.bind(this),
							3000
							);
					}else{
						$('.success_message').html('<div class="status_sucess"><h3>'+Props.useradd[0].message+'</h3></div>');
						scrollToTop();
						setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
					}

    		}
    	}
    }
	handleClickSelecet = (event) => {
		const selectedIndex = event.target.options.selectedIndex;
		var key = event.target.options[selectedIndex].getAttribute('data-key');
		this.setState({
				domain_id: key,
				
		})



	}

	handleCheckboxChange = (e) => {

  			this.setState({ functionalEndpoints: e.target.checked });
	};
removeNewFile = (index) => {
  const newFiles = [...this.state.json_files];
  const newPreviews = [...this.state.json_previews];

  newFiles.splice(index, 1);
  newPreviews.splice(index, 1);

  this.setState({
    json_files: newFiles,
    json_previews: newPreviews
  });
};

  render() {
	// const navigate = this.props.navigate;
	 const navigate = this.props.navigate;
  	const {selectedOption,selectedDomainOption} = this.state;
	  var	preview = <img className="img_class" src={this.state.image_preview} alt="" />;
    return (
      <div className="wrapper"> 
 
	  <Header />
    <MenuSidebar currentpage="json" />  

	
	<div className="content">	
		<div className="content-wrapper">
        <div class="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">

			<div className="success_message"></div>

			
						<div>
							<a class="btn" href="/json">Back</a>
						</div>
			
			<div className="title">
				<h4>Add File</h4>
			</div>
			<form className="login" id="login" onSubmit={e => { this.handleFormSubmit(this); e.preventDefault(); }}>
				<div className="form-row">
					<div className="form-left">
						<div className="form-group">
							<label>About JSON file<span class="required" style={{ color: "red" }} > * </span>:</label>
							<input type="text" name="json_title" onChange={this.handleInputChange} className="form-control" value={this.state.json_title} />
							<div className="error_json_title"></div>
						</div>
					<div className="form-group">
						<label>Upload Json file (allowed type: json only)<span className="required" style={{ color: "red" }} >* </span></label>
						<div className="choose-file">
						{this.state.isHidden && <div className="image_success"></div>}
						<span className="profile_btn">
							<input
							type="file"
							name="json_files"
							multiple
							accept=".json"
							onChange={this.onChangeHandler}
							/>
						</span>
						</div>
						<div className="errorimage"></div>

						<div className="preview-wrapper" style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
						

							{this.state.json_previews &&
								this.state.json_previews.map((file, index) => (
									<div
									key={index}
									style={{
										position: "relative",
										border: "1px solid #ddd",
										padding: "8px 12px",
										borderRadius: "6px",
										display: "flex",
										alignItems: "center",
										gap: "10px",
									}}
									>
									{/* Static JSON image */}
									<img
										src={jsonImg}
										alt="JSON file"
										style={{ width: "24px", height: "24px", objectFit: "contain" }}
									/>

									{/* File name */}
									<strong>{file.name}</strong>

									{/* Remove button */}
									<span
										onClick={() => this.removeFile(index)}
										style={{
										position: "absolute",
										top: "-5px",
										right: "-5px",
										background: "red",
										color: "white",
										borderRadius: "50%",
										width: "20px",
										height: "20px",
										textAlign: "center",
										lineHeight: "20px",
										cursor: "pointer",
										fontWeight: "bold",
										}}
									>
										×
									</span>
									</div>
								))}

						</div>
					</div>
					</div>

					<div className="form-right">

						<div className="form-group" style={{ marginTop: '20px' }}>
								<label>
									<input
									type="checkbox"
									checked={this.state.functionalEndpoints}
									onChange={this.handleCheckboxChange}
									style={{ marginRight: '8px' }}
									/>
									Functional Endpoints
								</label>
								<div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
									Hint: You are not allowed to remove the files
								</div>
								</div>
					<div className="default-font">
						<div className="form-group">
						<label>Status<span className="required" style={{ color: "red" }} >*</span></label>
						<Select
							value={this.state.selectedOption ? this.state.selectedOption : { value: 'active', label: 'Active' }}
							options={lang.common.status_option}
							onChange={this.handleChange}
						/>
						</div>
					</div>
					</div>
				</div>

				<div className="btn-group export">
					<button
					className="btn btn_orange btn_minwid login_submit animate-btn2"
					type="submit"
					disabled={this.state.Loading === true ? true : false}
					>
					{this.state.Loading === true &&
						<span className="load-data"></span>
					}
					Submit
					</button>
				</div>
				</form>

			</div>
				
		</div>	
	</div>
		 	
    </div>
    );
  }
}


export default withRouter(Add);